export default "__VITE_ASSET__116ce4a1__"